import React, { useState } from 'react'
import navigate from 'utils/navigate'
import { Menu, MenuItem } from '@material-ui/core'
import kebabCase from 'lodash/kebabCase'

import MenuButton from 'ui/header/MenuButton'
import useMenuLinks from 'ui/header/useMenuLinks'

import useCurrentUser from 'auth/useCurrentUser'
import AccountMenu from './AccountMenu'

export const goTo = (destination, callback) => () => {
  callback && callback()
  navigate(destination)
}

export const handleClose = setter => () => setter(null)

export const handleMenuClick = setter => ({ currentTarget }) =>
  setter(currentTarget)

const Item = ({ name, path, links, variant, onClick }) => {
  const hasSubmenu = !!links
  const [anchorEl, setAnchorEl] = useState(null)
  const id = `menu-appbar-${kebabCase(name)}`
  const props = hasSubmenu
    ? {
        'aria-label': name,
        'aria-controls': id,
        onClick: handleMenuClick(setAnchorEl),
      }
    : { path, variant, onClick }
  return (
    <React.Fragment>
      <MenuButton {...props}>{name}</MenuButton>
      {hasSubmenu && (
        <Menu
          id={id}
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          keepMounted
          open={!!anchorEl}
          onClose={handleClose(setAnchorEl)}
        >
          {links.map(subItem => (
            <MenuItem
              key={subItem.name}
              onClick={goTo(subItem.path, subItem.onClick)}
            >
              {subItem.name}
            </MenuItem>
          ))}
        </Menu>
      )}
    </React.Fragment>
  )
}

const DesktopMenu = () => {
  const [{ currentUser }] = useCurrentUser()
  const menuLinks = useMenuLinks()
  return (
    <React.Fragment>
      {currentUser && <AccountMenu />}
      {menuLinks.map(item => (
        <Item key={item.name} {...item} />
      ))}
    </React.Fragment>
  )
}

export default DesktopMenu
